import Vue from 'vue'
import router from '../router'
import store from '../store'
import ZJUtils from '../utils'
import ZJConfig from '../config'
import ZJTheme from '../theme'
import ZJApis from '../api'
// import ZJUser from '../user'
import ZJMenu from '../menu'
import ZJPlugins from './plugins'
// import components from '../components'
import views from './views'
import utils from '../utils'
// import emitter from '../mixins/emitter'
// import ZJNotify from '../notify'
// import ZJMeeting from '../meeting'
import NotifyClient from '../utils/NotifyClient.js'
const cmps = {
    Vue,
    router,
    store,
    // ...components,
    ...views,
    ZJUtils,
    ZJConfig,
    // ZJNotify,
    ZJTheme,
    ZJApis,
    // ZJUser,
    ZJMenu,
    ZJPlugins,
    // ZJMeeting
};

// 响应式扩展对象的属性
const reactiveExtend = ZJUtils.reactiveExtend = function () {
    let target = arguments[0] || {};
    for (let i = 1; i < arguments.length; i++) {
        let obj = arguments[i];
        if (obj) {
            for (var key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    Vue.set(target, key, obj[key]);
                }
            }
        }
    }
    return target;
}

const install = function(Vue) {
    Vue.reactiveExtend = reactiveExtend;
    Vue.use(ZJConfig);
    Vue.use(ZJTheme);
    // Vue.use(ZJUser);
    Vue.use(ZJMenu);
    // Vue.use(ZJNotify, {
    //      config: ZJConfig.current//,
    //      //user: ZJUser.current
    // });
    // Vue.mixin(emitter);
    // Vue.use(components);
    Vue.use(views);
    Vue.prototype.$notify = new NotifyClient();
}

let global = ZJUtils.global;
let vm = null;

// const updateRootFontSize = function() {
//     // 计算 rem 的基量
//     let x = ()=>document.documentElement.style.fontSize
//         = (10 * window.innerWidth / 1920) + 'px';
//     let timer;
//     let last = 0;
//     x();
//     window.onresize = function() {
//         let now = new Date().getTime();
//         if (last > now - 100) {
//             clearTimeout(timer);
//         }
//         last = now;
//         timer = setTimeout(function() {
//             x();
//         }, 100);
//     };
// };

const startup = function(opts) {
    return new Promise(function (resolve, reject) {
        try {
            opts = opts || {};

            //updateRootFontSize();

            vm = new Vue({
                router,
                store,
                render: h => h(views.ZjApp)
            }).$mount(opts.el || '#app');

            global.$app = vm;

            resolve(vm);
        }
        catch(e) {
            reject(e);
        }
    })
}

const bootstrap = function(opts) {
    if (vm) {
        return Promise.resolve(vm);
    }
    return utils.waitAll([
            ()=>ZJConfig.current.load(opts),
            ()=>ZJTheme.current.load(opts),
            ()=>startup(opts)
        ],
        r=>r[r.length-1]
    );
}

Vue.config.productionTip = false;

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    window.ZJApp = ZJUtils.extend(window.ZJApp, {
        ...cmps,
        bootstrap,
        install,
    });
    install(window.Vue);
}

export default {
    ...cmps,
    install,
    bootstrap,
};